import { render } from "./ModalTemplate.vue?vue&type=template&id=513d9658&scoped=true"
import script from "./ModalTemplate.vue?vue&type=script&lang=js"
export * from "./ModalTemplate.vue?vue&type=script&lang=js"

import "./ModalTemplate.vue?vue&type=style&index=0&id=513d9658&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-513d9658"]])

export default __exports__